import addIcon from './add.svg';
import ageIcon from './age.svg';
import androidMoreIcon from './android-more.svg';
import arrangeIcon from './arrange.svg';
import arrowDiagonalLeftIcon from './arrow-diagonal-left.svg';
import arrowDiagonalRightIcon from './arrow-diagonal-right.svg';
import arrowDownBigIcon from './arrow-down-big.svg';
import arrowLeftBigIcon from './arrow-left-big.svg';
import arrowRightBigIcon from './arrow-right-big.svg';
import arrowRotateClockwiseIcon from './arrow-rotate-clockwise.svg';
import arrowRotateAnticlockwiseIcon from './arrow-rotate-anticlockwise.svg';
import arrowRotateIcon from './arrow-rotate.svg';
import arrowUpBigIcon from './arrow-up-big.svg';
import arrowUpDownIcon from './arrow-up-down.svg';
import attachmentIcon from './attachment.svg';
import backArrowIcon from './back-arrow.svg';
import basketIcon from './basket.svg';
import bellCheckmarkIcon from './bell-checkmark.svg';
import bellNotificationAddIcon from './bell-notification-add.svg';
import bellIcon from './bell.svg';
import bookmarkIcon from './bookmark.svg';
import bulletListTextIcon from './bullet-list-text.svg';
import calendarIcon from './calendar.svg';
import cameraAddIcon from './camera-add.svg';
import cameraIcon from './camera.svg';
import carIcon from './car.svg';
import catIcon from './cat.svg';
import categoriesIcon from './categories.svg';
import chartBoardIcon from './chart-board.svg';
import chartIcon from './chart.svg';
import checkListIcon from './check-list.svg';
import checkboxCheckmarkIcon from './checkbox-checkmark.svg';
import checkboxDeleteIcon from './checkbox-delete.svg';
import checkboxMinusIcon from './checkbox-minus.svg';
import checkboxIcon from './checkbox.svg';
import checkmarkIcon from './checkmark.svg';
import chevronBackIcon from './chevron-back.svg';
import chevronDownIcon from './chevron-down.svg';
import chevronForwardIcon from './chevron-forward.svg';
import chevronUpIcon from './chevron-up.svg';
import circleCheckmarkIcon from './circle-checkmark.svg';
import circleDeleteIcon from './circle-delete.svg';
import circleMinusIcon from './circle-minus.svg';
import clockTimeArrowIcon from './clock-time-arrow.svg';
import clockIcon from './clock.svg';
import closeIcon from './close.svg';
import communityIcon from './community.svg';
import cropIcon from './crop.svg';
import deleteIcon from './delete.svg';
import diyIcon from './diy.svg';
import documentFileAddIcon from './document-file-add.svg';
import documentFileBlankIcon from './document-file-blank.svg';
import dogIcon from './dog.svg';
import downloadIcon from './download.svg';
import drivingConvenienceIcon from './driving-convenience.svg';
import dropdownUpIcon from './dropdown-up.svg';
import dropdownIcon from './dropdown.svg';
import engineIcon from './engine.svg';
import eyeHiddenIcon from './eye-hidden.svg';
import eyeViewIcon from './eye-view.svg';
import facebookIcon from './facebook.svg';
import filterIcon from './filter.svg';
import forwardArrowIcon from './forward-arrow.svg';
import fuelIcon from './fuel.svg';
import fullScreenIcon from './full-screen.svg';
import googleIcon from './google.svg';
import gumtreeHomeIcon from './gumtree-home.svg';
import heartIcon from './heart.svg';
import homeIcon from './home.svg';
import hypelinkOutIcon from './hypelink-out.svg';
import imageIcon from './image.svg';
import infoIcon from './info.svg';
import instagramIcon from './instagram.svg';
import interiorIcon from './interior.svg';
import iosMoreIcon from './ios-more.svg';
import jobsIcon from './jobs.svg';
import kidsIcon from './kids.svg';
import letterIcon from './letter.svg';
import lightBulbIcon from './light-bulb.svg';
import loaderIcon from './loader.svg';
import locationAndroidIcon from './location-android.svg';
import locationIosIcon from './location-ios.svg';
import locationIcon from './location.svg';
import lockIcon from './lock.svg';
import mapIcon from './map.svg';
import menuDotsCircleHorizIcon from './menu-dots-circle-horiz.svg';
import menuDotsCircleVertIcon from './menu-dots-circle-vert.svg';
import menuIcon from './menu.svg';
import messageBubbleIcon from './message-bubble.svg';
import messageLeftIcon from './message-left.svg';
import messageRecievedIcon from './message-recieved.svg';
import messageRightIcon from './message-right.svg';
import messagesIcon from './messages.svg';
import metaMessengerIcon from './meta-messenger.svg';
import microphoneIcon from './microphone.svg';
import milesIcon from './miles.svg';
import minusIcon from './minus.svg';
import overviewIcon from './overview.svg';
import penEditIcon from './pen-edit.svg';
import penIcon from './pen.svg';
import performanceIcon from './performance.svg';
import petsIcon from './pets.svg';
import phoneIcon from './phone.svg';
import pinterestIcon from './pinterest.svg';
import plusIcon from './plus.svg';
import privateIcon from './private.svg';
import propertiesIcon from './properties.svg';
import questionCircleIcon from './question-circle.svg';
import reportIcon from './report.svg';
import runningCostsIcon from './running-costs.svg';
import safetySecurityIcon from './safety-security.svg';
import saleIcon from './sale.svg';
import searchIcon from './search.svg';
import sendIcon from './send.svg';
import servicesIcon from './services.svg';
import settingIcon from './setting.svg';
import sexIcon from './sex.svg';
import shareAndroidIcon from './share-android.svg';
import shareIosIcon from './share-ios.svg';
import shareIcon from './share.svg';
import sortIcon from './sort.svg';
import spinnerIcon from './spinner.svg';
import sportsIcon from './sports.svg';
import starCheckMarkIcon from './star-check-mark.svg';
import starFilledIcon from './star-filled.svg';
import starHalfFilledIcon from './star-half-filled.svg';
import starIcon from './star.svg';
import stickersIcon from './stickers.svg';
import tradeIcon from './trade.svg';
import transmissionIcon from './transmission.svg';
import twitterIcon from './twitter.svg';
import userIcon from './user.svg';
import videoIcon from './video.svg';
import warningTriangleIcon from './warking-triangle.svg';
import warningIcon from './warning.svg';
import whatsupIcon from './whatsup.svg';
import youtubeIcon from './youtube.svg';
import zoomInIcon from './zoom-in.svg';
import zoomOutIcon from './zoom-out.svg';

export default {
    add: addIcon,
    age: ageIcon,
    'android-more': androidMoreIcon,
    arrange: arrangeIcon,
    'arrow-diagonal-left': arrowDiagonalLeftIcon,
    'arrow-diagonal-right': arrowDiagonalRightIcon,
    'arrow-down-big': arrowDownBigIcon,
    'arrow-left-big': arrowLeftBigIcon,
    'arrow-right-big': arrowRightBigIcon,
    'arrow-rotate-clockwise': arrowRotateClockwiseIcon,
    'arrow-rotate-anticlockwise': arrowRotateAnticlockwiseIcon,
    'arrow-rotate': arrowRotateIcon,
    'arrow-up-big': arrowUpBigIcon,
    'arrow-up-down': arrowUpDownIcon,
    attachment: attachmentIcon,
    'back-arrow': backArrowIcon,
    basket: basketIcon,
    'bell-checkmark': bellCheckmarkIcon,
    'bell-notification-add': bellNotificationAddIcon,
    bell: bellIcon,
    bookmark: bookmarkIcon,
    'bullet-list-text': bulletListTextIcon,
    calendar: calendarIcon,
    'camera-add': cameraAddIcon,
    camera: cameraIcon,
    car: carIcon,
    cat: catIcon,
    categories: categoriesIcon,
    'chart-board': chartBoardIcon,
    chart: chartIcon,
    'check-list': checkListIcon,
    'checkbox-checkmark': checkboxCheckmarkIcon,
    'checkbox-delete': checkboxDeleteIcon,
    'checkbox-minus': checkboxMinusIcon,
    checkbox: checkboxIcon,
    checkmark: checkmarkIcon,
    'chevron-back': chevronBackIcon,
    'chevron-down': chevronDownIcon,
    'chevron-forward': chevronForwardIcon,
    'chevron-up': chevronUpIcon,
    'circle-checkmark': circleCheckmarkIcon,
    'circle-delete': circleDeleteIcon,
    'circle-minus': circleMinusIcon,
    'clock-time-arrow': clockTimeArrowIcon,
    clock: clockIcon,
    close: closeIcon,
    community: communityIcon,
    crop: cropIcon,
    delete: deleteIcon,
    diy: diyIcon,
    'document-file-add': documentFileAddIcon,
    'document-file-blank': documentFileBlankIcon,
    dog: dogIcon,
    download: downloadIcon,
    'driving-convenience': drivingConvenienceIcon,
    'dropdown-up': dropdownUpIcon,
    dropdown: dropdownIcon,
    engine: engineIcon,
    'eye-hidden': eyeHiddenIcon,
    'eye-view': eyeViewIcon,
    facebook: facebookIcon,
    filter: filterIcon,
    'forward-arrow': forwardArrowIcon,
    fuel: fuelIcon,
    'full-screen': fullScreenIcon,
    google: googleIcon,
    heart: heartIcon,
    'gumtree-home': gumtreeHomeIcon,
    home: homeIcon,
    'hypelink-out': hypelinkOutIcon,
    image: imageIcon,
    info: infoIcon,
    instagram: instagramIcon,
    interior: interiorIcon,
    'ios-more': iosMoreIcon,
    jobs: jobsIcon,
    kids: kidsIcon,
    letter: letterIcon,
    'light-bulb': lightBulbIcon,
    loader: loaderIcon,
    'location-android': locationAndroidIcon,
    'location-ios': locationIosIcon,
    location: locationIcon,
    lock: lockIcon,
    map: mapIcon,
    'menu-dots-circle-horiz': menuDotsCircleHorizIcon,
    'menu-dots-circle-vert': menuDotsCircleVertIcon,
    menu: menuIcon,
    'message-bubble': messageBubbleIcon,
    'message-left': messageLeftIcon,
    'message-recieved': messageRecievedIcon,
    'message-right': messageRightIcon,
    messages: messagesIcon,
    'meta-messenger': metaMessengerIcon,
    microphone: microphoneIcon,
    miles: milesIcon,
    minus: minusIcon,
    overview: overviewIcon,
    'pen-edit': penEditIcon,
    pen: penIcon,
    performance: performanceIcon,
    pets: petsIcon,
    phone: phoneIcon,
    pinterest: pinterestIcon,
    plus: plusIcon,
    private: privateIcon,
    properties: propertiesIcon,
    'question-circle': questionCircleIcon,
    report: reportIcon,
    'running-costs': runningCostsIcon,
    'safety-security': safetySecurityIcon,
    sale: saleIcon,
    search: searchIcon,
    send: sendIcon,
    services: servicesIcon,
    setting: settingIcon,
    sex: sexIcon,
    'share-android': shareAndroidIcon,
    'share-ios': shareIosIcon,
    share: shareIcon,
    sort: sortIcon,
    spinner: spinnerIcon,
    sports: sportsIcon,
    'star-check-mark': starCheckMarkIcon,
    'star-filled': starFilledIcon,
    'star-half-filled': starHalfFilledIcon,
    star: starIcon,
    stickers: stickersIcon,
    trade: tradeIcon,
    transmission: transmissionIcon,
    twitter: twitterIcon,
    user: userIcon,
    video: videoIcon,
    'warning-triangle': warningTriangleIcon,
    warning: warningIcon,
    whatsup: whatsupIcon,
    youtube: youtubeIcon,
    'zoom-in': zoomInIcon,
    'zoom-out': zoomOutIcon,
};
